




























































import { Component, Vue, Watch } from "vue-property-decorator";
import Plugin from "@/components/Plugins/Item.vue";
import YAML from "yaml";

interface IPlugin {
  id: string;
  iid: string;
  path: string;
  args: Record<string, string>;
}

@Component({
  components: {
    Plugin
  }
})
export default class PluginPage extends Vue {
  plugins = [] as IPlugin[];
  counter = 0;

  mode = "json" as "json" | "yaml";

  output = "";

  events = {
    actorCreated: [],
    sceneCreated: [],
    actorCustom: [],
    sceneCustom: [],
    movieCreated: []
  };

  mounted() {
    this.compileOutput();
  }

  get unusedPlugins() {
    const pluginNames = [] as string[];
    for (const pluginName of this.plugins.map(p => p.id)) {
      let used = false;
      for (const eventName in this.events) {
        for (const usedPluginName of this.events[eventName]) {
          if (usedPluginName == pluginName) used = true;
        }
      }
      if (!used) pluginNames.push(pluginName);
    }
    return pluginNames;
  }

  get unknownPlugins() {
    const pluginNames = [] as string[];
    for (const eventName in this.events) {
      for (const pluginName of this.events[eventName]) {
        if (!this.plugins.find(p => p.id == pluginName)) {
          pluginNames.push(pluginName);
        }
      }
    }
    return pluginNames;
  }

  get hasConflictingIds() {
    const idMap = {} as Record<string, boolean>;
    for (const plugin of this.plugins) {
      if (idMap[plugin.id] !== undefined) return true;
      idMap[plugin.id] = true;
    }
    return false;
  }

  removePlugin(i: number) {
    this.plugins.splice(i, 1);
    if (this.plugins.length == 0) this.counter = 0;
  }

  copyOutput() {
    navigator.clipboard.writeText(this.output).then(
      () => {
        /* clipboard successfully set */
      },
      () => {
        /* clipboard write failed */
      }
    );
  }

  compileOutput() {
    const pluginMap = {} as Record<string, any>;

    for (const plugin of this.plugins) {
      const obj = {
        path: plugin.path,
        args: plugin.args
      };
      if (!Object.keys(plugin.args).length) delete obj.args;
      pluginMap[plugin.id] = obj;
    }

    if (this.mode == "json")
      this.output = JSON.stringify(
        { plugins: { register: pluginMap, events: this.events } },
        null,
        2
      );
    else
      this.output = YAML.stringify({
        plugins: {
          register: pluginMap,
          events: this.events
        }
      });
  }

  addPlugin() {
    this.plugins.push({
      id: "Plugin " + this.counter++,
      iid: this.counter.toString(),
      path: "",
      args: {}
    });
    this.compileOutput();
  }

  @Watch("plugins", { deep: true })
  onPluginChange() {
    this.compileOutput();
  }

  @Watch("events", { deep: true })
  onEventChange() {
    this.compileOutput();
  }
}
